import React from "react";
import { Row } from "reactstrap";
import PartBar from "../../components/bars/PartBar";

export const PlacementProgressbar = ({
  currentSectionPage,
  setCurrentSectionPage,
  data,
  currentPage,
  setCurrentPage,
  visited_pages,
  answers,
  pagination_color_decision,
}) => {
  const ClickOnPart = (props) => {
    setCurrentPage(props);
    setCurrentSectionPage(parseInt(`${props}${1}`));
  };
  return (
    <>
      <Row className="border bg-white  border-top-0 border-bottom-0 px-4 pb-3">
        <div className="progress-bar-container">
          <ul class="order-list-container ">
            {data &&
              data.sections &&
              data.sections.map((section, section_id) => {
                return (
                  <PartBar
                    currentPage={section.section_number}
                    pagination_color_decision={pagination_color_decision}
                    section_number={section.section_number}
                    standing_page={currentPage}
                    data={data}
                    answers={answers}
                    section_name={section.section_name}
                    onClick={(props) => ClickOnPart(props)}
                  />
                );
              })}
          </ul>
        </div>
      </Row>
      <p className="quiz-bottom-border mx-4"></p>
    </>
  );
};
